module.exports = __webpack_public_path__ + "static/media/olivier-bertil.7861c758.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/olivier-bertil.png
// module id = 1827
// module chunks = 0